import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Box, Layer, Scroller, Logo } from 'components'
import UserImg from 'images/tmp_user_image.png'
import styles from './index.module.css'
import { useLocation } from 'react-router-dom'
import Lib from 'library'
import shSymbol from 'images/tmp_shinhyup_symbol.png'


const InfluencerOthers = () => {

	const App = useApp()

	const location = useLocation()
	const [myInfoData, setMyInfoData] = useState()  // 유저정보
	const [otherInfoData, setOtherInfoData] = useState()  // 로그인한 유저정보
	const [portfolioData, setPortfolioData] = useState([]); // 포트폴리오
	const [target, setTarget] = useState(""); // 무한스크롤 하단 위치 target
	const [subScrY, setSubScrY] = useState('') // 구독 여부
	const [aplyMydata, setAplyMydata] = useState()	//마이데이터 연동 여부

	// 상세 페이지
	const assetMoreSliceN = 2;
	const [assetMoreBtn, setAssetMoreBtn] = useState(assetMoreSliceN)
	const [assetLength, setAssetLength] = useState(0)
	const [assetDetail, setAssetDetail] = useState()
	const [detailLayer, setDetailLayer] = useState(false)
	const [detailItem, setDetailItem] = useState()
	const [realTimeChange, setRealTimeChange] = useState(false)



	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")

		//마이데이터 연동 여부 확인
		Lib.get(`/api/data/v2/lnkup/chck`, {
			mbId: location.state?.mbIdData.mbId
		}, data => {
			setAplyMydata(data)
		})

	}, [])

	useEffect(() => {
		const mbIdData = location.state?.mbIdData
		const otherMbIdData = location.state?.otherMbIdData
		setOtherInfoData(otherMbIdData);
		Lib.post(`/api/infl/inf`, {
			mbId: mbIdData.mbId
		}, data => {
			setMyInfoData(data);
		});
	}, [realTimeChange])

	useEffect(() => {
		const mbIdData = location.state?.mbIdData
		Lib.post(`/api/infl/lst/rank`, data => {
			// console.log(data)
			const subScrState = data.find((item) => item.mbId === mbIdData.mbId)
			// console.log(subScrState)
			setSubScrY(subScrState.sbscrYn);
			// console.log('subScrState.sbscrYn');
			// console.log(subScrState.sbscrYn);
		});
	}, [realTimeChange])

	let infiniteN = 1;
	const onIntersect = ([entry]) => {
		const mbIdData = location.state?.mbIdData
		if (infiniteN === 5) { return false }
		if (entry.isIntersecting) {
			// // 데이터를 가져오는 부분
			Lib.post(`/api/infl/lst/dlyprtfl`, {
				mbId: mbIdData.mbId,
				pageNo: infiniteN
			}, data => {
				if (infiniteN === 1) {
					setPortfolioData(data);
				} else if (infiniteN > 1) {
					setPortfolioData((preState) => preState.concat(data));
				}
				infiniteN++
			});
		}
	};

	useEffect(() => {
		let observer;
		if (target) {
			// callback 함수, option
			observer = new IntersectionObserver(onIntersect, {
				threshold: 0.4,
			});
			observer.observe(target); // 타겟 엘리먼트 지정
		}
		return () => observer && observer.disconnect();
	}, [target]);


	const onChangeYear = (changeToday) => {
		let s = changeToday.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
		const newDay = Lib.ChanageNewDate(s);
		// 요일 찾기
		function getDayInfo() {
			// eslint-disable-next-line no-array-constructor
			var week = new Array('(일)', '(월)', '(화)', '(수)', '(목)', '(금)', '(토)');
			var today = newDay.getDay();
			var todayLabel = week[today];
			return todayLabel;
		}
		return getDayInfo();
	}

	// 구독 취소
	const onSbscCancle = (item) => {
		if (otherInfoData.mbId === item.mbId) {
			App.showAlert("해당 유저는 동일한 유저 입니다.")
			return false
		}
		Lib.post(`/api/infl/unsbscr`, {
			unsbscrMbId: item.mbId
		}, data => {
			setRealTimeChange(!realTimeChange)
		})
	}

	// 구독하기
	const onSbsc = (item) => {
		if (otherInfoData.mbId === item.mbId) {
			App.showAlert("해당 유저는 동일한 유저 입니다.")
			return false
		}
		Lib.post(`/api/infl/sbscr`, {
			sbscrMbId: item.mbId
		}, data => {
			setRealTimeChange(!realTimeChange)
		})
	}


	// 상세 페이지 기능
	// 더보기 버튼
	const assetMorebtnBox = () => {
		if (assetLength > 1 && (assetMoreBtn / assetMoreSliceN) < assetLength) {
			return (
				<div className="padding pb_50" onClick={assetMoreButton}>
					<Button className="btn btn--big btn-more">+ 더보기</Button>
				</div>
			)
		} else {
			return ''
		}
	}

	const assetMoreButton = () => {
		setAssetMoreBtn(assetMoreBtn + assetMoreSliceN)
	}

	const detailCloseLayer = () => {
		setDetailLayer(false)
	}

	const test = [
		{
			blncAmt: 5000000,
			de: "2022-03-10",
			dfrnAmt: 20000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "국민은행"
		},
		{
			blncAmt: 3000000,
			de: "2022-03-10",
			dfrnAmt: 10000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "신한은행"
		},
		{
			blncAmt: 5000000,
			de: "2022-03-10",
			dfrnAmt: 20000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "우리은행"
		},
		{
			blncAmt: 5000000,
			de: "2022-03-10",
			dfrnAmt: 20000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "국민은행"
		},
		{
			blncAmt: 3000000,
			de: "2022-03-10",
			dfrnAmt: 10000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "신한은행"
		},
		{
			blncAmt: 5000000,
			de: "2022-03-10",
			dfrnAmt: 20000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "우리은행"
		},
		{
			blncAmt: 5000000,
			de: "2022-03-10",
			dfrnAmt: 20000,
			indstCd: "1",
			indstDtlCd: "2",
			insttCd: "3",
			insttNm: "우리은행"
		}
	]

	const openDetailLayer = (item) => {
		setDetailLayer(true)
		setDetailItem(item);
		Lib.post(`/api/infl/lst/dlyprtfl/dtl`, {
			de: item.de,
			mbId: myInfoData.mbId
		}, data => {
			setAssetLength(Math.ceil(data.length / assetMoreSliceN));
			setAssetDetail(data.slice(0, assetMoreBtn))
		});
	}

	useEffect(() => {
		if (!detailItem) { return  }
		Lib.post(`/api/infl/lst/dlyprtfl/dtl`, {
			de: detailItem ? detailItem.de : '',
			mbId: myInfoData ? myInfoData.mbId : ''
		}, data => {
			setAssetLength(Math.ceil(data.length / assetMoreSliceN));
			setAssetDetail(data.slice(0, assetMoreBtn))
		});
	}, [assetMoreBtn])

	const DetailPortpolio = (item) => {
		if (!item) { return false }
		if (item.cmntImgFileId === '') {
			return (
				<li style={{ width: "100%" }}>
					<div className="balance" style={{ padding: "0 1rem" }}>
						{
							item.dfrnAmt === 0 ?
								<i className="icon icon_balance_same" />
								:
								item.dfrnAmt > 0 ?
									<i className="icon icon_balance_arrow_right" />
									:
									item.dfrnAmt < 0 ?
										<i className="icon icon_balance_arrow_left" />
										:
										""
						}
						<ul className="balance-area">
							<li>
								<i className={`icon ${item.dfrnAmt < 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
								<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(item.blncAmt)}원</p>
							</li>
							<li>
								<i className={`icon ${item.dfrnAmt > 0 ? "money-less" : "money-many"} mt_0`} style={{ width: "8rem", height: "5.1rem" }} />
								<p className="price">{Lib.addComma(item.blncAmt - item.dfrnAmt)}원</p>
							</li>
						</ul>
					</div>
				</li>
			)
		} else {
			return (
				<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
					<li style={{ width: "100%" }}>
						<div className="balance" style={{ padding: "0 1rem" }}>
							{item.dfrnAmt === 0 ? <i className="icon icon_balance_same" /> : <i className="icon icon_balance_arrow" />}
							{/* <i className="icon icon_balance_arrow" /> */}
							<ul className="balance-area">
								<li>
									<i className="icon money-many mt_0" style={{ width: "8rem", height: "5.1rem" }} />
									<p className="price price-today" style={{ fontSize: "1.6rem" }}>{Lib.addComma(item.blncAmt)}원</p>
								</li>
								<li>
									<i className="icon money-less mt_0" style={{ width: "8rem", height: "5.1rem" }} />
									<p className="price">{Lib.addComma(item.blncAmt - item.dfrnAmt)}원</p>
								</li>
							</ul>
						</div>
					</li>
					{item.cmntImgFileId && (
						<li style={{ width: '100%' }} >
							<img style={{ width: '100%', height: '10rem' }} src={`/api/comm/showImage/${item.cmntImgFileId}`} alt='' />
						</li>
					)}
				</Scroller>
			)
		}
	}

	// 상세 페이지 기능

	return (
		<div className="page">
			{myInfoData && (
				<div className="shadow">
					<div className="padding">
						<div className="flex-align_center">
							<div className="img-box user-profile profile_80">
								{myInfoData && (
									<img src={"/images/profile/influencer_profile" + myInfoData.prflCd + ".svg"} alt="프로필 이미지" />
								)}
							</div>
							<div className="flex--item_1 ml_20">
								<div className="flex-justify_between align_center">
									<h3>{myInfoData.ncknm}</h3>
									{subScrY && subScrY === "Y" && (
										<span className="text-red" style={{ fontWeight: 500 }} onClick={() => onSbscCancle(myInfoData)}>구독취소</span>
									)}
								</div>
								<p className="mt_5" style={{ fontSize: "1.2rem", color: "#999" }}>Since. {Lib.dateFormat(myInfoData.joinDe, ".")}</p>
								<div className="flex-align_center mt_10">
									<i className="tag tag-lg tag-green">#{myInfoData.ageGroup}대</i>
									<i className="tag tag-lg tag-green ml_10">#{myInfoData.gendr === 'M' ? '남성' : '여성'}</i>
								</div>
								<p className="mt_10 flex-align_center" style={{ fontSize: "1.2rem" }}><span className="text-blue">{myInfoData.sbscredCnt}명</span>이 구독중입니다.</p>
							</div>
						</div>
						<div className={`${styles["tag-wrap"]} mt_20`}>
							{myInfoData.amt1001 > 10000 && <span>#은행잔고{(999999 > myInfoData.amt1001 && myInfoData.amt1001 > 10000) ? Lib.numberToKorean(Math.floor(myInfoData.amt1001 / 10000) * 10000) : Lib.numberToKorean(Math.floor(myInfoData.amt1001 / 100000) * 100000)}원대</span>}
							{myInfoData.amt1002 > 10000 && <span>#예금{(999999 > myInfoData.amt1002 && myInfoData.amt1002 > 10000) ? Lib.numberToKorean(Math.floor(myInfoData.amt1002 / 10000) * 10000) : Lib.numberToKorean(Math.floor(myInfoData.amt1002 / 100000) * 100000)}원대</span>}
							{myInfoData.amt1003 > 10000 && <span>#적금{(999999 > myInfoData.amt1003 && myInfoData.amt1003 > 10000) ? Lib.numberToKorean(Math.floor(myInfoData.amt1003 / 10000) * 10000) : Lib.numberToKorean(Math.floor(myInfoData.amt1003 / 100000) * 100000)}원대</span>}
						</div>
						{subScrY && subScrY === 'N' && (
							<Button onClick={() => onSbsc(myInfoData)} className="btn btn--big btn-more mt_30" style={{ background: "var(--main-color)", color: "#fff" }}>+ 구독하기</Button>
						)}
					</div>
				</div>
			)}
			<div>
				{/* 데이터 있을 때 */}
				{aplyMydata && aplyMydata.hasLnkupData ?
					<>
						{portfolioData && subScrY === "Y" && (
							<div className="bg-violet padding">
								{portfolioData.map((item, index) => {
									return (
										<div className="mb_20" key={index}>
											<strong>{Lib.dateFormat(item.de, ".")} {onChangeYear(item.de)} </strong>
											<Box className="mt_10" onClick={() => openDetailLayer(item)}>
												<div className="slider mt_10">
													<ul>
														{DetailPortpolio(item)}
													</ul>
												</div>
												<div className={`${styles["money-guide"]} mt_20`}>
													어제대비 <strong className={`${item.dfrnAmt >= 0 ? "text-red" : "text-blue"}`}>{item.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(item.dfrnAmt)} 원</strong>
												</div>
												{item.cmnt !== '' && (
													<p className="mt_20" style={{ textAlign: "justify" }}>{item.cmnt}</p>
												)}
											</Box>
										</div>
									)
								})}
								<div ref={setTarget}></div>
							</div>
						)}
						{/* 데이터 없을 때 */}
						{subScrY && subScrY === "N" && (
							<div className="center-cont py_50">
								<i className="icon icon_other_search" style={{ width: "13rem", height: "11rem" }} />
								<p className="mt_20" style={{ fontSize: "1.6rem" }}><strong>구독하면 {myInfoData && myInfoData.ncknm}</strong>님의<br />포트폴리오를 확인할 수 있어요!</p>
							</div>
						)}
					</>
					:
					<div className="center-cont py_80">
						<span className="icon icon_no_data" />
						<p className="mt_20">발행된 데이터가 없습니다.</p>
					</div>
				}
			</div>
			<DetailLayer show={detailLayer} closeLayer={detailCloseLayer} myInfoData={myInfoData} onChangeYear={onChangeYear} assetDetail={assetDetail} assetMoreButton={assetMoreButton} assetMorebtnBox={assetMorebtnBox} DetailPortpolio={DetailPortpolio} detailItem={detailItem} />
		</div>
	)
}

const DetailLayer = ({ show, closeLayer, myInfoData, assetDetail, detailItem, assetMorebtnBox, onChangeYear, DetailPortpolio }) => {
	return (
		<Layer title={'상세페이지'} show={show} closeLayer={closeLayer}>
			<div className="page padding">
				<div className="" style={{ borderBottom: '1px solid #d9d9d9' }}>
					<div className="mb_20">
						<h4><strong>{myInfoData && myInfoData.ncknm}</strong>님의<br />포트폴리오</h4>
						<div className="slider mt_10">
							<ul className={styles["box-line"]}>
								{DetailPortpolio(detailItem)}
							</ul>
						</div>
						<div className="mt_50">
							<div className="flex-justify_between align_center mt_30">
								<strong>{detailItem && Lib.dateFormat(detailItem.de, ".")}{detailItem && onChangeYear(detailItem.de)}</strong>
								{/* <span className="write-btn" ><i className="icon icon_write icon_write mr_5" />수정</span> */}
							</div>
							<div className="mt_10 flex-align_center" style={{ fontSize: "1.6rem" }}>어제대비<strong className={`${detailItem && detailItem.dfrnAmt >= 0 ? "text-red" : "text-blue"} ml_5 `}>{detailItem && detailItem.dfrnAmt >= 0 ? "+" : ""}{detailItem && Lib.addComma(detailItem.dfrnAmt)}원</strong></div>
							{detailItem && detailItem.cmnt !== '' && (
								<>
									<hr className="my_20" />
									<div>{detailItem.cmnt}</div>
								</>
							)}
						</div>
					</div>
				</div>
				<ul className={`${styles["bank-list"]} list-bg mt_40`}>
					{assetDetail && assetDetail.length > 0 ? assetDetail.map((item, index) => {
						return (
							<li key={index}>
								<div className="flex-align_center">
									<div className="img-box img-symbol">
										<Logo code={item.insttCd} style={{ 'width': '4rem', 'height': '4rem' }} />
									</div>
									<span className="ml_10">{item.insttNm}</span>
								</div>
								<div>
									<p className={styles.price}>{Lib.addComma(item.blncAmt)}</p>
									<span className={`${styles.info} ${item.dfrnAmt >= 0 ? "plus" : "minus"}`}>{item.dfrnAmt >= 0 ? "+" : ""}{Lib.addComma(item.dfrnAmt)}원</span>
								</div>
							</li>
						)
					}) : '오늘은 어제대비 계좌잔액 변동이 없어요.'}
				</ul>
				{assetMorebtnBox()}
			</div>
		</Layer>
	)
}

export default InfluencerOthers
